import React from 'react';

const GoogleMap = ({ embedUrl }) => {
  return (
    <div style={{ width: '100%', height: '400px', overflow: 'hidden',marginBottom:'20px' }}>
      <iframe
        src={embedUrl}
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      ></iframe>
    </div>
  );
};
export default GoogleMap;